<template>
    <div class="cabinet-detail-table">
        <div
            v-if="product.ItemInsert"
            class="cabinet-detail-table__row pb-4"
            v-html="product.ItemInsert"
        />

        <div
            v-if="!product.inserts.length && !product.ItemInsert"
            class="cabinet-detail-table__row"
        >
            Вставки отсутствуют
        </div>

        <div v-for="(insert, i) in product.inserts" :key="insert.ItemInsertID">
            <div
                class="cabinet-detail-table__title"
                :class="
                    i === 0
                        ? 'cabinet-detail-table__row '
                        : 'cabinet-detail-table__row--divided '
                "
            >
                {{ insert.material.Name }}
            </div>

            <div
                v-if="insert.Quantity"
                class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key"
                        >Количество камней</span
                    >
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.Quantity }}
                </div>
            </div>

            <div
                v-if="insert.color"
                class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Цвет вставки</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.color.Name }}
                </div>
            </div>

            <div
                v-if="insert.Clarity"
                class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key"
                        >Чистота вставки</span
                    >
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.Clarity }}
                </div>
            </div>

            <div
                v-if="insert.facet"
                class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Огранка</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.facet.Name
                    }}<span v-if="insert.FaceNumber"
                        >, граней: {{ insert.FaceNumber }}</span
                    >
                </div>
            </div>

            <div
                v-if="insert.Size"
                class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key"
                        >Общая каратность</span
                    >
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ insert.Size }} crt
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DetailInserts',
    computed: {
        ...mapState('supplierProducts', ['product'])
    }
}
</script>
